import { NgZone, OnInit, Component, } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router'
import { } from 'googlemaps';
import { CookieService, MyOrderService } from '../_services/index';

declare var $: any;
declare var google: any;
declare var jQuery: any;
declare var REP: any;
declare var gtag: Function;

@Component({
    moduleId: module.id,
    templateUrl: 'onhold.component.html',
    styleUrls: ['onhold.component.css']
})
export class OnholdComponent implements OnInit {
    onHoldType: string;
    onHoldGeom: any;
    onHoldEmail: string;
    onHoldBound = [];
    errorInfo = "";
    confirmation = "";
    validationInfo = "";

    constructor(private router: Router, private ngZone: NgZone, private cookieService: CookieService, private myOrderService: MyOrderService) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // gtag('js', new Date());
                // gtag('config', 'UA-65756200-2');
            }
        });
    }

    updateOnhold(customerId: string, orderid: string, email: string, type: string, geom: string, skey: string) {
        this.myOrderService.setonholdGeom(customerId, orderid, email, type, geom, skey).subscribe(result => {
            this.ngZone.run(() => {
                this.confirmation = result;
            })
        }, error => this.errorInfo = error);
    }

    ngOnInit() {
        if (!this.cookieService.getCookie('customerID')) {
            return;
        }
        let map;
        let drawingMode;
        let drawingManager;
        let savedGeoLayer;
        let totalPoly = [];
        let chosenGeo = [];
        let searchmarker;
        let parcelOn = true;
        let totalRequested = 0;
        let totalOverlay = [];
        let selectedOverlay;
        let selectedShape;
        let infoWindow = null;
        let parcelInfoWindow = null;
        let mapFeatures = [];
        let polyIw;
        let myShape;
        let allPoly = [];
        let xmax, xmin, ymax, ymin;
        let that = this;
        if ((this.cookieService.getCookie('onholdType')) && (this.cookieService.getCookie('onholdGeom'))) {

            this.onHoldEmail = this.cookieService.getCookie('onholdEmail');
            this.onHoldType = this.cookieService.getCookie('onholdType');
            this.onHoldGeom = JSON.parse(this.cookieService.getCookie('onholdGeom'));
            ymax = parseFloat(this.cookieService.getCookie("maxx")) + 0.0115;
            ymin = parseFloat(this.cookieService.getCookie("minx")) - 0.0115;
            xmax = parseFloat(this.cookieService.getCookie("maxy")) + 0.0085;
            xmin = parseFloat(this.cookieService.getCookie("miny")) - 0.0085;
            this.onHoldBound = [{ lat: xmin, lng: ymin }, { lat: xmin, lng: ymax }, { lat: xmax, lng: ymax }, { lat: xmax, lng: ymin }];


            let geom = this.onHoldGeom[0][0];
            let Center = new google.maps.LatLng(geom[1], geom[0]);
            let Zoom = 15;


            let el = document.getElementById("updateMap");
            let mapOp = {
                center: Center,
                zoom: Zoom,
                fullscreenControl: false,
                streetViewControl: false,
                zoomControl: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControlOptions: {
                    position: google.maps.ControlPosition.TOP_LEFT,
                },
            };
            map = new google.maps.Map(el, mapOp);
            let range = new google.maps.Polygon({
                paths: this.onHoldBound,
                strokeColor: 'rgb(195,212,47)',
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: 'rgb(195,212,47)',
                fillOpacity: 0,
                clickable: false,
                map: map
            });
            let icon = {
                url: "assets/images/Site_Marker.png",
                scaledSize: new google.maps.Size(60, 40), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(30, 40)
            };

            if ((that.onHoldGeom) && (that.onHoldType)) {
                that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(that.onHoldGeom));
                that.cookieService.setCookieSession("modifyType", that.onHoldType);
                let savedGeoType = this.onHoldType;
                let Geom = this.onHoldGeom;

                if (Geom.length > 0) {
                    let savedGeom = Geom[0];
                    let savedGeom1 = [];
                    for (let i = 0; i < savedGeom.length; i++) {
                        let pointJson = { lat: savedGeom[i][1], lng: savedGeom[i][0] };
                        savedGeom1.push(pointJson);
                    }

                    if (savedGeoType == "POLYGON") {
                        savedGeoLayer = new google.maps.Polygon({
                            paths: savedGeom1,
                            strokeColor: '#000',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: 'rgb(195,212,47)',
                            fillOpacity: 0.65,
                            map: map
                        });
                    } else if (savedGeoType == "POLYLINE") {
                        savedGeoLayer = new google.maps.Polyline({
                            path: savedGeom1,
                            geodesic: true,
                            strokeColor: '#000',
                            strokeOpacity: 1.0,
                            strokeWeight: 2,
                            map: map
                        });
                    } else if (savedGeoType == "POINT") {
                        savedGeoLayer = new google.maps.Marker({
                            position: savedGeom1[0],
                            icon: icon,
                            anchorPoint: new google.maps.Point(0, -25),
                            map: map,
                        });
                    }
                }

                //draw geometry
                let toolbarDiv = document.getElementById('topToobar');
                map.controls[google.maps.ControlPosition.TOP_RIGHT].push(toolbarDiv);
                let polyOptions = {
                    strokeWeight: 2,
                    strokeColor: '#000',
                    fillColor: 'rgb(195,212,47)',
                    fillOpacity: 0.65,
                    editable: true,
                };

                drawingManager = new google.maps.drawing.DrawingManager({
                    drawingMode: null,
                    markerOptions: {
                        icon: icon,
                        anchorPoint: new google.maps.Point(0, -25),
                    },
                    polylineOptions: {
                        editable: true,
                        strokeWeight: 2,
                        strokeColor: '#000',
                    },

                    rectangleOptions: polyOptions,
                    circleOptions: polyOptions,
                    polygonOptions: polyOptions,
                    map: map
                });
                drawingMode = 'hand';
                drawingManager.setOptions({
                    drawingControl: false
                });

                google.maps.event.addListener(map, 'overlaycomplete', event => {
                    if (event.type !== google.maps.drawing.OverlayType.MARKER) {
                        map.setDrawingMode(null);
                        google.maps.event.addListener(event.overlay, 'click', e => {
                            selectedOverlay = event.overlay;
                            selectedOverlay.setEditable(true);
                        });
                        selectedOverlay = event.overlay;
                    }
                });

                google.maps.event.addListener(drawingManager, 'overlaycomplete', function (e) {
                    if (polyIw) polyIw.close();
                    if (savedGeoLayer) { savedGeoLayer.setMap(null); }
                    for (let poly of allPoly) {
                        poly.setMap(null)
                    }
                    allPoly = [];
                    if (myShape) {


                        allPoly = [];
                        allPoly.push(myShape);
                    }
                    let newShape = e.overlay;
                    myShape = e.overlay;
                    myShape.type = e.type;
                    newShape.type = e.type;
                    if (e.type !== google.maps.drawing.OverlayType.MARKER) {
                        // Switch back to non-drawing mode after drawing a shape.
                        drawingManager.setDrawingMode(null);
                        let compareResult = compareRange(myShape, newShape.type);//
                        let modifiedGeom = compareResult[0];
                        if (compareResult[1]) {
                            if (myShape) {
                                myShape.setMap(null);;
                            } else {
                                alert("yo")
                            }

                            if (e.overlay) {
                                e.overlay.setMap(null);;
                            }
                            let type = newShape.type;
                            newShape.setMap(null);
                            //drawing a new shape based on modifiedGeom
                            if (type == "polygon") {
                                myShape = new google.maps.Polygon({
                                    paths: modifiedGeom,
                                    strokeColor: '#000',
                                    strokeOpacity: 0.8,
                                    strokeWeight: 2,
                                    fillColor: 'rgb(195,212,47)',
                                    fillOpacity: 0.65,
                                    editable: true,
                                    map: map
                                });
                                google.maps.event.trigger(drawingManager, 'overlaycomplete', { type: "polygon", overlay: myShape });
                            } else if (type == "polyline") {
                                myShape = new google.maps.Polyline({
                                    path: modifiedGeom,
                                    geodesic: true,
                                    strokeColor: '#000',
                                    strokeOpacity: 1.0,
                                    strokeWeight: 2,
                                    editable: true,
                                    map: map
                                });
                                google.maps.event.trigger(drawingManager, 'overlaycomplete', { type: "polyline", overlay: myShape });
                            }
                        } else {

                            myShape = e.overlay; allPoly.push(myShape);
                        }

                        let gpoly = [];
                        let selectedGeometry = [];
                        calArea(compareResult[2], newShape.type);
                        gpoly = getPoly(compareResult[2]);

                        selectedGeometry.push(gpoly);
                        that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(selectedGeometry));
                        that.cookieService.setCookieSession("modifyType", newShape.type);

                        //end reverse

                        gpoly = getPoly(compareResult[2]);

                        selectedGeometry.push(gpoly);

                        google.maps.event.addListener(myShape, 'click', function (e) {

                            if (e.vertex !== undefined) {
                                if (newShape.type === google.maps.drawing.OverlayType.POLYGON) {
                                    let path = myShape.getPaths().getAt(e.path);
                                    path.removeAt(e.vertex);
                                    if (path.length < 3) {
                                        myShape.setMap(null);
                                        if (polyIw) {
                                            polyIw.close();
                                        }
                                    }
                                }
                                if (newShape.type === google.maps.drawing.OverlayType.POLYLINE) {

                                    let path = myShape.getPath();
                                    path.removeAt(e.vertex);
                                    if (path.length < 2) {
                                        myShape.setMap(null);
                                        if (polyIw) {
                                            polyIw.close();
                                        }
                                    }
                                }
                            }
                            let compareResult = compareRange(myShape, newShape.type);
                            let modifiedGeom = compareResult[0];
                            if (compareResult[1]) {

                                let type = newShape.type;
                                if (myShape) {
                                    myShape.setMap(null);;
                                }
                                newShape.setMap(null);
                                //drawing a new shape based on modifiedGeom
                                if (type == "polygon") {
                                    myShape = new google.maps.Polygon({
                                        paths: modifiedGeom,
                                        strokeColor: '#000',
                                        strokeOpacity: 0.8,
                                        strokeWeight: 2,
                                        fillColor: 'rgb(195,212,47)',
                                        fillOpacity: 0.65,
                                        editable: true,
                                        map: map
                                    });
                                } else if (type == "polyline") {
                                    myShape = new google.maps.Polyline({
                                        path: modifiedGeom,
                                        geodesic: true,
                                        strokeColor: '#000',
                                        strokeOpacity: 1.0,
                                        strokeWeight: 2,
                                        editable: true,
                                        map: map
                                    });
                                }
                            }

                            let gpoly = [];
                            let selectedGeometry = [];

                            calArea(compareResult[2], newShape.type);
                            gpoly = getPoly(compareResult[2]);

                            selectedGeometry.push(gpoly);

                            setSelection(newShape);
                            that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(selectedGeometry));
                            that.cookieService.setCookieSession("modifyType", newShape.type);
                        });

                        google.maps.event.addListener(myShape.getPath(), 'set_at', function (e) {
                            if (polyIw) polyIw.close();
                            if (e.vertex !== undefined) {
                                if (newShape.type === google.maps.drawing.OverlayType.POLYGON) {
                                    let path = myShape.getPaths().getAt(e.path);
                                    path.setAt(e.vertex);
                                    if (path.length < 3) {
                                        myShape.setMap(null);
                                    }
                                }
                                if (newShape.type === google.maps.drawing.OverlayType.POLYLINE) {

                                    let path = myShape.getPath();
                                    path.setAt(e.vertex);
                                    if (path.length < 2) {
                                        myShape.setMap(null);
                                    }
                                }
                            }
                            let compareResult = compareRange(myShape, newShape.type);
                            let modifiedGeom = compareResult[0];
                            if (compareResult[1]) {

                                let type = newShape.type;
                                if (myShape) {
                                    myShape.setMap(null);;
                                }
                                newShape.setMap(null);
                                //drawing a new shape based on modifiedGeom
                                if (type == "polygon") {
                                    myShape = new google.maps.Polygon({
                                        paths: modifiedGeom,
                                        strokeColor: '#000',
                                        strokeOpacity: 0.8,
                                        strokeWeight: 2,
                                        fillColor: 'rgb(195,212,47)',
                                        fillOpacity: 0.65,
                                        editable: true,
                                        map: map
                                    });
                                    google.maps.event.trigger(drawingManager, 'overlaycomplete', { type: "polygon", overlay: myShape });
                                } else if (type == "polyline") {
                                    myShape = new google.maps.Polyline({
                                        path: modifiedGeom,
                                        geodesic: true,
                                        strokeColor: '#000',
                                        strokeOpacity: 1.0,
                                        strokeWeight: 2,
                                        editable: true,
                                        map: map
                                    });
                                    google.maps.event.trigger(drawingManager, 'overlaycomplete', { type: "polyline", overlay: myShape });
                                }
                            }

                            let gpoly = [];
                            let selectedGeometry = [];
                            calArea(compareResult[2], newShape.type);
                            gpoly = getPoly(compareResult[2]);

                            selectedGeometry.push(gpoly);
                            setSelection(newShape);
                            that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(selectedGeometry));
                            that.cookieService.setCookieSession("modifyType", newShape.type);
                        });
                        
                        google.maps.event.addListener(myShape.getPath(), 'insert_at', function (e) {
                            if (e.vertex !== undefined) {
                                if (newShape.type === google.maps.drawing.OverlayType.POLYGON) {
                                    let path = newShape.getPaths().getAt(e.path);
                                    path.insertAt(e.vertex);
                                    if (path.length < 3) {
                                        newShape.setMap(null);
                                    }
                                }
                                if (newShape.type === google.maps.drawing.OverlayType.POLYLINE) {
                                    let path = newShape.getPath();
                                    path.insertAt(e.vertex);
                                    if (path.length < 2) {
                                        newShape.setMap(null);
                                    }
                                }
                            }
                            setSelection(newShape);

                            let compareResult = compareRange(newShape, newShape.type);
                            let modifiedGeom = compareResult[0];
                            if (compareResult[1]) {

                                let type = newShape.type;
                                if (myShape) {
                                    myShape.setMap(null);;
                                }
                                newShape.setMap(null);
                                //drawing a new shape based on modifiedGeom
                                if (type == "polygon") {
                                    myShape = new google.maps.Polygon({
                                        paths: modifiedGeom,
                                        strokeColor: '#000',
                                        strokeOpacity: 0.8,
                                        strokeWeight: 2,
                                        fillColor: 'rgb(195,212,47)',
                                        fillOpacity: 0.65,
                                        editable: true,
                                        map: map
                                    });
                                } else if (type == "polyline") {
                                    myShape = new google.maps.Polyline({
                                        path: modifiedGeom,
                                        geodesic: true,
                                        strokeColor: '#000',
                                        strokeOpacity: 1.0,
                                        strokeWeight: 2,
                                        editable: true,
                                        map: map
                                    });
                                }
                                google.maps.event.trigger(drawingManager, 'overlaycomplete', { type: "polygon", overlay: myShape });
                            }

                            let gpoly = [];
                            let selectedGeometry = [];
                            calArea(compareResult[2], newShape.type);
                            gpoly = getPoly(compareResult[2]);

                            selectedGeometry.push(gpoly);

                            that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(selectedGeometry));
                            that.cookieService.setCookieSession("modifyType", newShape.type);
                        })
                    } else {
                        myShape = e.overlay; allPoly.push(myShape);
                        let oriGeom = [];
                        let modifiedGeom = [];
                        let oripoint = { lat: e.overlay.position.lat(), lng: e.overlay.position.lng() };

                        oriGeom.push(oripoint);

                        let gpoly = [];
                        let selectedGeometry = [];

                        let gpoint = [e.overlay.position.lng(), e.overlay.position.lat()];

                        gpoly.push(gpoint);
                        selectedGeometry.push(gpoly);
                        that.cookieService.setCookieSession("modifyGeometry", JSON.stringify(selectedGeometry));
                        that.cookieService.setCookieSession("modifyType", "POINT");
                        google.maps.event.addListener(newShape, 'click', function (e) {
                        });
                        setSelection(newShape);
                    }
                });
                google.maps.event.addListener(drawingManager, 'drawingmode_changed', clearSelection);
            } else {
                // else clause
            }
        }

        function setSelection(shape) {
            if (shape.type !== 'marker') {
                clearSelection();
                shape.setEditable(true);
            }
            selectedShape = shape;
        }

        function clearSelection() {
            if (selectedShape) {
                if (selectedShape.type !== 'marker') {
                    selectedShape.setEditable(false);
                }
                selectedShape = null;
            }
        }

        jQuery(function ($) {

            $('#button-delete').click(function () {
                $('#white-background').css('display', 'block');

                if (savedGeoLayer) { savedGeoLayer.setMap(null) }

                for (let i = 0; i < allPoly.length; i++) {
                    allPoly[i].setMap(null);
                }
                allPoly = [];
                if (polyIw) polyIw.close();
                that.cookieService.deleteCookie("modifyGeometry");
                that.cookieService.deleteCookie("modifyType");
            });
            $('#button-parcel').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingManager.setDrawingMode(null);
                parcelToggle();
            });
            $('#gmdm-hand').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = 'hand';
                drawingManager.setDrawingMode(null);
                $('#gmdm-' + drawingMode).addClass('selected');
            });
            $('#gmdm-marker').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = google.maps.drawing.OverlayType.MARKER;
                drawingManager.setDrawingMode(drawingMode);
                $('#gmdm-' + drawingMode).addClass('selected');
                if (polyIw) polyIw.close();
            });
            $('#gmdm-polyline').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = google.maps.drawing.OverlayType.POLYLINE;
                drawingManager.setDrawingMode(drawingMode);
                $('#gmdm-' + drawingMode).addClass('selected');
                if (polyIw) polyIw.close();
            });

            $('#gmdm-polygon').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = google.maps.drawing.OverlayType.POLYGON;
                drawingManager.setDrawingMode(drawingMode);
                $('#gmdm-' + drawingMode).addClass('selected');
                if (polyIw) polyIw.close();
            });
        });

        function compareRange(shape, type) {
            let modifiedGeom = [];
            let flag = false;
            for (let i = 0; i < shape.getPath().length; i++) {

                let glat = shape.getPath().getAt(i).lat();
                let glng = shape.getPath().getAt(i).lng();
                let gpoint = { lat: shape.getPath().getAt(i).lat(), lng: shape.getPath().getAt(i).lng() };
                modifiedGeom.push(gpoint);//
            }

            if (modifiedGeom.length > 0) {
                for (let geom of modifiedGeom) {

                    if (geom.lat > xmax) {
                        geom.lat = xmax - 0.000000000001;
                        flag = true;
                    }
                    if (geom.lat < xmin) {
                        geom.lat = xmin + 0.00000000000001;
                        flag = true;
                    }
                    if (geom.lng > ymax) {
                        geom.lng = ymax - 0.0000000001;
                        flag = true;
                    }
                    if (geom.lng < ymin) {
                        geom.lng = ymin + 0.000000000001;
                        flag = true;
                    }
                }
            }
            let paths = [];
            for (let point of modifiedGeom) {
                let path = new google.maps.LatLng(point.lat, point.lng)
                paths.push(path);
            }

            return [modifiedGeom, flag, paths];
        }

        function calArea(path, type) {

            let Content, geomArea;
            if (type == "polygon") {
                geomArea = Math.round(google.maps.geometry.spherical.computeArea(path) * 0.00024711);
                Content = "<strong>Polygon area</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea + " acres";
            } else if (type == "polyline") {
                geomArea = Math.round(google.maps.geometry.spherical.computeLength(path));
                Content = "<strong>Line length</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea + " meters"
            }
            //return Content
            if (geomArea > 0) {
                if (polyIw) {
                    polyIw.close();
                }
                let polyIndex = Math.ceil(((path).length) / 2);
                let lat = path[polyIndex].lat();
                let lng = path[polyIndex].lng();
                let iwPostion = { lat, lng };

                polyIw = new google.maps.InfoWindow({
                    position: iwPostion,
                    content: '<div style=\"width:150px; height:50px\">' + Content + "</div>",
                });
                polyIw.open(map);
            }
        }

        function getPoly(path) {
            let gpoly = [];
            for (let i = 0; i < path.length; i++) {
                let glat = path[i].lat();
                let glng = path[i].lng();
                let gpoint = [path[i].lng(), path[i].lat()];
                gpoly.push(gpoint);
            }
            return gpoly
        }

        function parcelToggle() {

            if (parcelOn) {
                parcelOn = false;
                if (parcelInfoWindow !== null) parcelInfoWindow.close();
                for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                //remove parcel tile
                map.overlayMapTypes.clear();
            } else {
                parcelOn = true;
                REP.Layer.Google.Initialize(map);
            }
        }
    }

    public saveOnhold(): void {
        let geom = "";
        let type = "";
        let email = '';
        let orderid = "";
        if (this.cookieService.getCookie("onholdOrderId")) {
            orderid = this.cookieService.getCookie("onholdOrderId");
        }

        if ((this.cookieService.getCookie("modifyGeometry")) && (this.cookieService.getCookie("modifyType"))) {

            geom = this.cookieService.getCookie("modifyGeometry");
            type = this.cookieService.getCookie("modifyType");
            if (type == "polygon") {
                let geomArray = JSON.parse(geom)
                geomArray[0].push(geomArray[0][0]);
                geom = JSON.stringify(geomArray);
            }
        };

        if ($("#emailInput").val() != "") {
            email = $("#emailInput").val();
        } else {
            email = "";
        }

        if ($("#confirmChk").prop('checked')) {
            if (this.cookieService.getCookie('customerID') && this.cookieService.getCookie("sessionKey") && (orderid != "") && (geom != "") && (type != "")) {
                let ID = this.cookieService.getCookie('customerID');
                let sessionKey = this.cookieService.getCookie("sessionKey");
                this.updateOnhold(ID, orderid, email, type, geom, sessionKey);
                $('#resModal').modal({
                    backdrop: 'static',
                    keyboard: false  // to prevent closing with Esc button (if you want this too)
                });
                $("#resModal").modal("show");
            } else {
                this.validationInfo = "Your geometry is invalid!"
            }
        } else {
            this.validationInfo = "*Please check the checkbox to proceed."
        }
    }
}
